import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import { HeaderData } from 'src/app/_models/header-data';
import { DatePipe } from '@angular/common';
import { ReportsService } from 'src/app/_services/reports.service';
import {PRODUCT_CONFIG} from '../../_common/product-config';
import { StatusCode, Modules } from 'src/app/_common/_enum/module.enum';
import { RESULTS_NOT_FOUND } from 'src/app/_common/product-config';
import { CommonService } from 'src/app/_services/common.service';

@Component({
  selector: 'app-claims-acknowledgement-report',
  templateUrl: './claims-acknowledgement-report.component.html',
  styleUrls: ['./claims-acknowledgement-report.component.scss']
})
export class ClaimsAcknowledgementReportComponent implements OnInit {

  //Create HeaderData object to show the Data on Blue Header.
  private headerData:HeaderData;
  private loading: boolean = false;
  private claimReport: any;
  private selectedInsured: any;
  private productConfig = PRODUCT_CONFIG;
  private hasAccess: boolean = true;

  resultsNotFound = RESULTS_NOT_FOUND;

  //private killServicesOnDestroy = [];

  constructor(private readonly route: ActivatedRoute, private readonly router: Router, private reportsService: ReportsService, private commonService: CommonService) { }

  ngOnInit() {
    /* Setting Headers Starts */
    this.headerData = new HeaderData();
    this.setHeaderData();
    /* Setting Headers Ended */

    this.fetchClaimAcknowledgementReport();
  }

  setHeaderData(){
    let pipe = new DatePipe('en-US');
    this.headerData.pageTitle = 'Claims Acknowledgement';this.headerData.breadcrumb = [{ itemName: 'REPORTS', itemLink: ''}];
    this.reportsService.header = this.headerData;
  }

  fetchClaimAcknowledgementReport() {
    this.loading = true;
    this.hasAccess = this.commonService.checkPermission(Modules.ReportClaimAck);
    if(this.hasAccess){
      let claimAcknowledgementReportSubscription = this.reportsService.fetchClaimAcknowledgementReport().subscribe(response => {
        this.loading = false;
        this.claimReport = response;
        this.claimReport.producers.forEach(producer => {
          producer.insureds.forEach(insured => {
            insured.isSelected = false;
          });
        });
        if(this.claimReport.producers && this.claimReport.producers.length > 0 && this.claimReport.producers[0].insureds){
          this.openInsured(this.claimReport.producers[0].insureds[0]);
        }
      },error=>{
        this.loading = false;
        this.claimReport = null;
        this.hasAccess = !(error.status == StatusCode.NoAccess);
      });

      this.reportsService.runningServices.push(claimAcknowledgementReportSubscription);
    }else{
      this.loading = false;
    }
  }

  openInsured(_selectedInsured) {
    this.claimReport.producers.forEach(producer => {
      producer.insureds.forEach(insured => {
        insured.isSelected = false;
      });
    });

    this.selectedInsured = _selectedInsured;
    this.selectedInsured.isSelected = true;
  }

  ngOnDestroy() {
    this.reportsService.runningServices.forEach(subscription =>subscription.unsubscribe());
  }
}